export default __webpack_public_path__ + "static/media/fb_icon.34e6139d.svg";